<template>
	<div class="aboutContent">
		<div class="top" style="height: 75px;display: grid;text-align:center;margin-bottom:50px;">
			<span style="font-size: 26px;font-weight: 900;color: #98273A;">资讯动态</span>
			<span style="padding-top: 5px;color: #98273A;">Information Dynamics</span>
		</div>
		<div class="middle">
			<div class="left" style="float: left;margin-top: 40px;">
				<img  @click="toDetail(tableData[0])" style="width: 86%;max-height: 250px;cursor: pointer;" :src="tableData[0]&&tableData[0].image?tableData[0].image:''">
				<span @click="toDetail(tableData[0])" class="newsInformationTitle" style="width: 86%;padding-top: 17px;font-size: 16px;line-height: 28px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;cursor: pointer;">{{tableData[0].title}}</span>
				<span  @click="toDetail(tableData[0])" style="padding-top: 15px;font-size: 14px;line-height: 24px;width: 86%;color: #595959;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;cursor: pointer;">{{tableData[0].description}}</span>
				<!-- <button  @click="goAbout()" :style="{'margin-top':'50px',width:'120px',left:' 200px',color:'white','font-size':'14px',height:'33px','line-height':'33px','text-align':'center','background-color':'#98273A',border:'0'}">了解更多</button> -->
			</div>
			<div class="right" style="float: left;margin-top: 40px;max-height:400px">
				<div style="height: 150px;">
					<div style="float: left;width: 14%;background-color: #98273A;height: 150px;">
						<div style="text-align: center;margin-top: 20px;color: #DFDFDF;font-size: 14px;">{{tableData[1].publish?tableData[1].publish.substring(0,7):''}}</div>
						<div style="color: white;font-size: 34px;margin-top: 15px;text-align: center;padding-bottom: 20px;width: 65%;margin-left: 17.5%;;border-bottom: 1px solid #DFDFDF;">{{tableData[1].publish?tableData[1].publish.substring(8,10):''}}</div>
					</div>
					<div style="float: left;width: 80%;margin-left: 6%;height: 170px;">
						<div @click="toDetail(tableData[1])" class="newsInformationTitle" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;padding-bottom: 20px;border-bottom: 1px solid #DFDFDF;cursor: pointer;">{{tableData[1].title}}</div>
						<div @click="toDetail(tableData[1])" style="padding-top: 20px;font-size: 14px;color: #595959;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;line-height: 24px;-webkit-box-orient: vertical;cursor: pointer;">{{tableData[1].description}}</div>
						<button @click="toDetail(tableData[1])" style="margin-top: 20px;background-color: white;color: #98273A;border: 1px solid #98273A;border-radius: 5px;cursor: pointer;">查看详情</button>
					</div>
				</div>
				<div style="height: 150px;margin-top: 45px;">
					<div style="float: left;width: 14%;background-color: #98273A;height: 150px;">
						<div style="text-align: center;margin-top: 20px;color: #DFDFDF;font-size: 14px;">{{tableData[2].publish?tableData[1].publish.substring(0,7):''}}</div>
						<div style="color: white;font-size: 34px;margin-top: 15px;text-align: center;padding-bottom: 20px;width: 65%;margin-left: 17.5%;;border-bottom: 1px solid #DFDFDF;">{{tableData[2].publish?tableData[2].publish.substring(8,10):''}}</div>
					</div>
					<div style="float: left;width: 80%;margin-left: 6%;height: 170px;">
						<div @click="toDetail(tableData[2])" class="newsInformationTitle" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;padding-bottom: 20px;border-bottom: 1px solid #DFDFDF;cursor: pointer;">{{tableData[2].title}}</div>
						<div @click="toDetail(tableData[2])" style="padding-top: 20px;font-size: 14px;color: #595959;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;line-height: 24px;-webkit-box-orient: vertical;cursor: pointer;">{{tableData[2].description}}</div>
						<button @click="toDetail(tableData[2])" style="margin-top: 20px;background-color: white;color: #98273A;border: 1px solid #98273A;border-radius: 5px;cursor: pointer;">查看详情</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {query} from "@/api/article";
	export default{
		data() {
			return {
				tableData: [],
			}
		},
		mounted() {
			this.list()
		},
		methods:{
			async toDetail(item,index){
				this.$router.push(
					{
						path:'/newsDetail',
						query:{
							id:item.id
						}
					}
				);
			},
			//查询栏目列表
			list() {
				let param = {
					page: 1,
					channelId: 13,
					pageSize:3,
					title:''
				}
				query(param).then(data => {
					this.tableData = data.data.list
					console.log(this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
			goAbout(){
				this.$router.push({
					path: "/channel_detail/"+'4',
				})
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">

	.newsInformationTitle:hover{
		color: rgb(152, 39, 58);
	}
	.aboutContent{
		width: 64%;
		padding: 30px 18%;
		padding-top: 100px;
		height: 500px;
		// display: flex;
		flex-direction: row;
		// justify-content: space-between;
		.left{
			width: 53%;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			.cmpName{
				width: 100%;
				height: 50px;
				font-size: 28px;
				font-family: Adobe Heiti Std R;
				color: #2E2E2E;
				line-height: 33px;
				border-bottom: 2px solid #469DFF;
			}
			.cmpInfo{
				width: 600px;
				padding: 10px 0;
				font-size: 21px;
				font-family: Adobe Heiti Std R;
				color: #838383;
				line-height: 33px;
			}
			.button{
				width: 120px;
				height: 36px;
				color: #FFFFFF;
				font-size: 16px;
				line-height: 36px;
				text-align: center;
				border-radius: 20px;
				background-color: #1A86FF;
				cursor: pointer;
				margin-top: 20px;
			}
		}
		.right{
			width: 47%;
			height: 100%;
		}
	}
</style>
